import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import {
  FundraiseActivityDocument,
  useSaveNoteMutation as useBaseMutation,
  useSaveNoteModalLazyQuery as useBaseLazyQuery
} from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';



const __formSchema = yup.object({
  title: yup.string().required('Title is required'),
  body: yup.string().max(250, 'Must be no more than 250 characters')
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;

export function useSaveNote(id: string) {
  const [fnRunQuery, tuple] = useBaseLazyQuery({});

  React.useEffect(() => {
    if (id) {
      fnRunQuery({
        variables: {
          id
        }
      });
    }
  }, [fnRunQuery, id]);

  const [saveNote, saveNoteTuple] = __useSaveNoteMutation();
  const loading = useLoading([tuple, saveNoteTuple]);

  const note = tuple.data?.note;
  const data = React.useMemo(() => ({
    id: note?.id,
    title: note?.title,
    body: note?.body
  }), [note]);

  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema),
    defaultValues: {
      title: '',
      body: ''
    },
    shouldFocusError: true
  });



  React.useEffect(() => {
    form.reset(_.omit(data, 'id'));

  }, [form, data]);



  return {
    form,
    data,
    loading,
    mutations: { saveNote }
  };
}



export interface ISaveNoteArgs {
  id?: string;
  investorCardId?: string;
  title: string;
  body?: string;
}

function __useSaveNoteMutation() {
  const [fnMutate, tuple] = useBaseMutation({
    refetchQueries: [
      FundraiseActivityDocument,
      'FundraiseActivity'
    ]
  });

  async function fnWrappedMutate(args: ISaveNoteArgs) {
    const input = _.merge(
      {
        title: args.title,
        body: args.body
      },

      args.id ? { id: args.id } : { investorCardId: args.investorCardId }
    );

    await fnMutate({
      variables: { input }
    });
  }

  return [fnWrappedMutate, tuple] as const;
}
